'use client';

import Slider, { Settings } from 'react-slick';
import { defaultSettings } from 'constant';
import { StaticImageData } from 'next/image';

import { StaticMediaImage } from 'ui/StaticMediaImage';

type CarouselProps = {
  banners: StaticImageData[];
  settings?: Settings;
  borderRadius?: number;
};

const Carousel = ({
  banners,
  settings = {},
  borderRadius = 0
}: CarouselProps) => {
  const carouselSettings = { ...defaultSettings, ...settings };
  const safeBanners = banners.filter(
    (b) =>
      b &&
      typeof b === 'object' &&
      'src' in b &&
      typeof b.src === 'string' &&
      b.src.length > 0
  );

  if (safeBanners.length === 0) return null;

  return (
    <Slider {...carouselSettings} adaptiveHeight variableWidth={false}>
      {safeBanners.map((banner) => (
        <div key={banner.src}>
          <StaticMediaImage
            src={banner}
            alt='Marketing banner'
            priority
            quality={100}
            style={{
              objectFit: 'cover',
              width: '100%',
              borderRadius
            }}
          />
        </div>
      ))}
    </Slider>
  );
};

export default Carousel;
